import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { IssueReportTopicGet } from "../../../models/IssueReportTopic"
import { useHashTab } from "../../../../hooks/useHashTab"
import { IssueReportTopicDetails } from "./details_tab/IssueReportTopicDetails"

const returnURL = "/issue-reports#topics"

export function IssueReportTopicContainer() {
  const { issueReportTopicId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [issueReportTopic, setIssueReportTopic] = useState<IssueReportTopicGet>()

  useEffect(() => {
    if (issueReportTopicId) {
      digitalManagerApi
        .get<IssueReportTopicGet>(`/issueReportTopics/${issueReportTopicId}`)
        .then((res) => {
          setIssueReportTopic(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, issueReportTopicId])

  if (!issueReportTopicId) {
    return <Navigate to={returnURL} />
  }

  if (!issueReportTopic) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: issueReportTopic.name,
    label: "Issue report topic ID",
    subtitle: issueReportTopic.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <IssueReportTopicDetails
          issueReportTopic={issueReportTopic}
          setIssueReportTopic={setIssueReportTopic}
        />
      )}
    </div>
  )
}
